import { Component, Input } from '@angular/core';
import { AuditInfo } from '../../../interfaces/audit.interfaces';

@Component({
  selector: 'app-audit-info',
  templateUrl: './audit-info.component.html',
  styleUrls: ['./audit-info.component.scss']
})
export class AuditInfoComponent {
  @Input() auditData!: AuditInfo;
  @Input() showExpanded: boolean = false;
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  @Input() layout: 'horizontal' | 'vertical' | 'compact' = 'compact';

  isExpanded = false;

  constructor() { }

  toggleExpanded(): void {
    this.isExpanded = !this.isExpanded;
  }

  formatDate(date: Date | string | undefined): string {
    if (!date) return 'No disponible';

    const dateObj = typeof date === 'string' ? new Date(date) : date;
    const day = dateObj.getDate().toString().padStart(2, '0');
    const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
    const year = dateObj.getFullYear();
    const hours = dateObj.getHours().toString().padStart(2, '0');
    const minutes = dateObj.getMinutes().toString().padStart(2, '0');
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }

  getRelativeTime(date: Date | string | undefined): string {
    if (!date) return '';
    
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    const now = new Date();
    const diffInMs = now.getTime() - dateObj.getTime();
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
    const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
    const diffInMinutes = Math.floor(diffInMs / (1000 * 60));

    if (diffInDays > 0) {
      return `hace ${diffInDays} día${diffInDays > 1 ? 's' : ''}`;
    } else if (diffInHours > 0) {
      return `hace ${diffInHours} hora${diffInHours > 1 ? 's' : ''}`;
    } else if (diffInMinutes > 0) {
      return `hace ${diffInMinutes} minuto${diffInMinutes > 1 ? 's' : ''}`;
    } else {
      return 'hace un momento';
    }
  }

  hasAuditData(): boolean {
    if (!this.auditData) return false;
    
    // Verificar si al menos uno de los campos de auditoría existe y tiene valor
    return !!(this.auditData.createdBy || this.auditData.createdAt || 
              this.auditData.updatedBy || this.auditData.updatedAt ||
              this.auditData.deletedBy || this.auditData.deletedAt);
  }
}
